import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ApiService, UtilService, VariablesService, VwoService } from 'src/app/shared/services';
import { MatRippleModule } from '@angular/material/core';
import { BasicButtonComponent } from '../basic-button/basic-button.component';
import { IncrementBtnComponent } from '../increment-btn/increment-btn.component';
import { environment } from 'src/environments/environment';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { DonateNowModule } from 'src/app/common/donate-now/donate-now.module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-extra-product-select',
  standalone: true,
  imports: [
    CommonModule, BasicButtonComponent, IncrementBtnComponent, SharedModule, MatRippleModule,
    DonateNowModule
  ],
  templateUrl: './extra-product-select.component.html',
  styleUrls: ['./extra-product-select.component.scss']
})
export class ExtraProductSelectComponent implements OnInit, OnDestroy {

  currency;
  kCartData: any[];

  @ViewChild('kitInfo', { static: true }) kitInfo;
  @ViewChild('costBreak', { static: true }) costBreak;

  images = {
    atta: '/assets/images/grocery/atta.png',
    atta_kit: '/assets/images/grocery/atta.png',
    dal: '/assets/images/grocery/dal.png',
    dal_kit: '/assets/images/grocery/dal.png',
    eggs: '/assets/images/grocery/eggs-1.png',
    eggs_kit: '/assets/images/grocery/eggs.png',
    fruits_vegetables: '/assets/images/grocery/fruits-vegetables.png',
    fruits_vegetables_kit: '/assets/images/grocery/fruits-vegetables.png',
    milk: '/assets/images/grocery/milk-1.png',
    milk_kit: '/assets/images/grocery/milk.png',
    oil: '/assets/images/grocery/oil-1.png',
    oil_kit: '/assets/images/grocery/oil.png',
    pulses: '/assets/images/grocery/pulses.png',
    pulses_kit: '/assets/images/grocery/pulses.png',
    rice: '/assets/images/grocery/rice-1.png',
    rice_kit: '/assets/images/grocery/rice.png',
    sugar: '/assets/images/grocery/sugar-1.png',
    sugar_kit: '/assets/images/grocery/sugar.png',
    wheat: '/assets/images/grocery/wheat-1.png',
    wheat_kit: '/assets/images/grocery/wheat.png'
  };

  params;

  isMobile;

  currency_symbol = '';

  selectedItems = [];
  selectedIds = [];

  selectedKit;

  totalAmount = 0;

  showCostBreak = false;
  openPaymentForm = false;

  isLoading;

  subs: Subscription[] = [];

  constructor(
    private api: ApiService,
    public bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
    public util: UtilService,
    public vars: VariablesService,
    public vwo: VwoService
  ) { }

  ngOnInit(): void {
    this.params = { ...this.util.actRoute.snapshot.queryParams };
    this.isMobile = this.util.isMobile();
    this.subs.push(this.util.actRoute.queryParams.subscribe(p => {
      if (!p?.payment && this.openPaymentForm) {
        this.openPaymentForm = false;
      }
    }));
    this.subs.push(this.vars.paymentFormAction.subscribe(action => {
      if (action === 'closed') {
        this.openPaymentForm = false;
        if (this.util.actRoute.snapshot.queryParams?.st === 'f') {
          this.util.router.navigate([], { queryParams: { st: null }, queryParamsHandling: 'merge' });
        }
      }
    }));
    this.subs.push(this.vars.resetSelectedKCart.subscribe(state => {
      if (state) {
        this.selectedItems = [];
        this.selectedIds = [];
        this.vars.kCartDockData = null;
        this.vars.selectedKCart = null;
        this.totalAmount = 0;
      }
    }));

    if (this.util.isBrowser && this.isMobile) {
      document.body.classList.add('mb-5');
      document.body.classList.add('pb-5');
    }

    this.subs.push(this.vars.kCartCurrencyChange.subscribe(d => {
      if (d && d?.currency !== this.currency) {
        this.currency = d.currency;
        this.currency_symbol = this.util.getCurrencyIcon(this.currency).symbol;
        this.getProducts(d?.preSelect);
      }
    }));
  }

  getProducts(pre = true) {
    this.getProductApi().then(res => {
      if (res && pre) {
        this.preSelect();
      }
    });
  }

  getProductApi() {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      let url = environment.APP.API_URLS.GET_CAMPAIGN_PRODUCTS(this.vars.fundraiser.id) + `?currency=${this.currency}&showError=false&page=${this.vars.pageName}&device=${this.vars.deviceType}`;
      if (this.vwo.kcart_slab_AB()) {
        url = url + `&kcart_slab_AB=${this.vwo.kcart_slab_AB()}`;
      }
      const utms = this.util.getUTMonly('url_string');
      if (utms) {
        url = url + `&${utms}`;
      }
      this.api.get(url).subscribe({
        next: (resp) => {
          if (resp?.data?.length) {
            resp['data'] = resp.data.map((val,index) => {
              val['selectedQuantity'] = (this.currency === 'INR' && index === 0) ? 2 : 1;
              return val;
            });
            this.kCartData = resp?.data;
          } else {
            this.vars.showKCart = false;
            this.kCartData = null;
          }
          this.isLoading = false;
          resolve(true);
        },
        error: (err) => {
          this.isLoading = false;
          reject(false);
        }
      });
    });
  }

  preSelect() {
    const cartData = this.util.storage.getFromSession('cartData');
    const preData: any[] = cartData?.campaign_products || [];
    if (this.util.actRoute.snapshot.queryParams?.st === 'f' && !preData?.length) {
      if (this.vars.pageName.match('stories|mini_story') && !this.isMobile) {
        this.openPayment();
      }
      return;
    }
    if (preData && preData?.length > 0) {
      preData.forEach((val, index) => {
        const kCart = this.kCartData.filter(pro => pro?.id === val.id)[0];
        this.add(kCart);
        const defaultCount = (this.currency === 'INR' && index === 0) ? 2 : 1;
        if (val.unit_count > defaultCount) {
          for (let i = defaultCount; i < val.unit_count; i++) {
            this.incrementAction('+', kCart);
          }
        }
      });
      if (this.vars.pageName.match('stories|mini_story') && !this.isMobile) {
        this.openPayment();
      }
    } else {
      if (this.vars.pageName === 'stories' && !this.vwo.kcart_not_preselected_AB()) {
        this.add(this.kCartData[0]);
      }
      if (this.vars.pageName === 'campaign') {
        this.add(this.kCartData[0]);
      }
    }
  }

  add(item) {
    this.selectedItems.push(item);
    this.selectedIds.push(item?.id);
    this.calulateAmount();
  }

  remove(item) {
    this.selectedItems = this.selectedItems.filter(val => val?.id !== item?.id);
    this.selectedIds = this.selectedIds.filter(val => val !== item?.id);
    this.calulateAmount();
  }

  incrementAction(e, item) {
    if (this.selectedIds.includes(item?.id)) {
      if (e === '-' && item?.selectedQuantity === 1) {
        this.remove(item);
        return;
      }
      this.kCartData = this.kCartData.map(val => {
        if (val?.id === item?.id) {
          e === '-' ? --val.selectedQuantity : ++val.selectedQuantity;
        }
        return val;
      });
      this.calulateAmount();
    }
  }

  calulateAmount() {
    this.vars.kCartDockData = null;
    this.vars.selectedKCart = null;
    this.totalAmount = 0;
    if (this.selectedItems?.length > 0) {
      this.vars.selectedKCart = [];
      this.selectedItems.forEach(item => {
        const data = {
          id: item?.id,
          name: item?.name,
          per_unit_amount: item?.perUnit,
          unit_count: item?.selectedQuantity
        }
        this.vars.selectedKCart.push(data);
        this.totalAmount += (item.selectedQuantity * item.perUnit);
      });
    }
    this.vars.kKartSelectionChange.next({ amount: this.totalAmount, currency: this.currency });
    this.setKCartDockData();
  }

  setKCartDockData() {
    this.vars.kCartDockData = { image: '', title: 'Please add a product', amount: this.totalAmount, currency_symbol: this.currency_symbol };
    if (this.selectedItems.length === 0) {
      return;
    }
    this.vars.kCartDockData.title = this.selectedItems[0]?.name;
    if (this.selectedItems?.length === 1) {
      this.vars.kCartDockData.image = this.selectedItems[0]?.type !== 'kit' ? this.selectedItems[0]?.product?.image : '/assets/images/grocery/grocery-kit.png';
    } else {
      this.selectedItems.forEach(item => {
        if (item?.type === 'kit') {
          this.vars.kCartDockData.image = '/assets/images/grocery/grocery-kit.png';
        }
        if (!this.vars.kCartDockData?.image && item?.type !== 'kit') {
          this.vars.kCartDockData.image = item?.product?.image;
        }
      });
      this.vars.kCartDockData.title += ' +' + (this.selectedItems?.length - 1) + ` item${this.selectedItems.length > 2 ? 's' : ''}`;
    }
  }

  openCostBreak() {
    if (!this.totalAmount) { return; }
    if (this.showCostBreak) {
      this.closeDialog();
      return;
    }
    this.showCostBreak = true;
    if (this.util.isMobile()) {
      this.bottomSheet.open(this.costBreak, {
        panelClass: 'cost-break-wrap-sheet',
      }).afterDismissed().subscribe(() => {
        this.showCostBreak = false;
      });
    } else {
      this.dialog.open(this.costBreak, {
        width: '500px',
        panelClass: 'cost-break-wrap-dialog'
      }).afterClosed().subscribe(() => {
        this.showCostBreak = false;
      });;
    }
  }

  openPayment() {
    // if (!this.vars.selectedKCart && this.util.isBrowser) {
    //   window.scrollTo({ top: 400, behavior: 'smooth' });
    //   this.util.openSnackBar('Please add atleast 1 product', 'error')
    //   return;
    // }
    this.openPaymentForm = true;
  }

  viewKitInfo(item) {
    this.selectedKit = item;
    if (this.util.isMobile()) {
      this.bottomSheet.open(this.kitInfo, {
        panelClass: 'kit-info-wrap-sheet',
      });
    } else {
      this.dialog.open(this.kitInfo, {
        width: '500px',
        panelClass: 'kit-info-wrap-dialog'
      });
    }
  }

  otherAmount() {
    this.selectedItems = [];
    this.selectedIds = [];
    this.calulateAmount();
    if (this.isMobile || (this.vars.pageName !== 'stories' && !this.isMobile)) {
      this.openPaymentForm = true;
    }
  }

  closeDialog() {
    this.dialog.closeAll();
    this.bottomSheet.dismiss();
    this.showCostBreak = false;
  }

  ngOnDestroy(): void {
    if (this.util.isBrowser && this.isMobile) {
      document.body.classList.remove('mb-5');
      document.body.classList.remove('pb-5');
    }
    this.subs.forEach(s => s.unsubscribe());
  }
}
